import React from "react";

import { useIntl } from "react-intl";

import { authCommonStyles as commonStyles } from "@mapmycustomers/auth";

const ExpiredCodeError = () => {
  const intl = useIntl();
  return (
    <div className={commonStyles.container}>
      <p className={commonStyles.title}>
        {intl.formatMessage({
          id: "auth.registerMember.error.expiredCode.title",
          defaultMessage: "Your invite has expired",
          description: "Title of the expired code state in the member register form",
        })}
      </p>
      <p className={commonStyles.description}>
        {intl.formatMessage(
          {
            id: "auth.registerMember.error.expiredCode.description",
            defaultMessage:
              "Your invitation link to join Map My Customers is no longer valid. Please use the Password Reset link {here} or contact {email} for additional assistance.",
            description: "Description of the expired code state in the member register form",
          },
          {
            email: <a href="mailto:support@mapmycustomers.me">support@mapmycustomers.me</a>,
            here: (
              <a
                href="https://app2.mapmycustomers.com/forgot-password"
                rel="noreferrer"
                target="_blank"
              >
                here
              </a>
            ),
          }
        )}
      </p>
    </div>
  );
};

export default ExpiredCodeError;
